import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useReveal } from "@/lib/motion";

// White band between the hero and the gallery (25:42 / 25:49 / 25:51): a 55px
// heading, the list of what the service suits, and an orange CTA.

export const ServiceIdealFor = ({ service }) => {
    // Above the guard: useReveal is a hook, so it has to run on every render,
    // including the ones that bail out below.
    const reveal = useReveal();

    if (!service.idealFor?.length) return null;

    return (
        <section className="bg-paper px-6 pb-[190px] pt-[110px] text-center">
            <div className="mx-auto flex max-w-[1340px] flex-col items-center">
                <motion.h2
                    className="type-display max-w-[813px] text-balance text-[clamp(30px,3.8vw,55px)] leading-[0.8] text-brand"
                    {...reveal()}
                >
                    {service.idealForTitle ?? "Ideal para empresas que desejam:"}
                </motion.h2>

                <motion.ul
                    className="mt-[70px] max-w-[725px] space-y-1 text-[clamp(17px,1.7vw,24px)] text-ink"
                    {...reveal(0.08)}
                >
                    {service.idealFor.map((item) => (
                        <li key={item}>{item}</li>
                    ))}
                </motion.ul>

                <motion.div className="mt-[76px]" {...reveal(0.16)}>
                    <Link
                        to="/contato"
                        className="type-display inline-flex h-[52px] w-[182px] items-center justify-center bg-brand text-[22px] text-paper btn-sweep [--sweep:theme(colors.brand.deep)]"
                    >
                        INICIAR PROJETO
                    </Link>
                </motion.div>
            </div>
        </section>
    );
};
